<template>
    <transition name="slide-fade">
        <div class="modal ff-reg" :class="{ 'open': open }" v-if="open">
            <div class="modal-content mx-auto max-w-md px-5">
                <div class="bg-white w-full rounded-40 p-4">
                    <div class="modal-base" :class="theme">
                        <div class="modal-base-body">
                            <div class="title mt-2">{{ lbl.confirm.title }}</div>
                            <div class="customer-info">{{ lbl.convert.theOneNumber }} {{ cardNo }}</div>
                            <div class="customer-info">{{ lbl.convert.theOneName }} {{ theOneFullName }}</div>

                            <ConvertHeader class="pt-4" :lbl="lbl" mode="point" :hideProfile="true"
                                :userProfile="theOneProfile" :showTitle="false" :blobConfig="blobConfig"
                                :pointRaw="pointRaw" :pointConverted="pointConverted" :toApp="toApp" />
                            <div class="warning-text">
                                {{ lbl.confirm.warning_text }}
                            </div>
                        </div>
                        <div class="modal-base-footer">
                            <div class="wrapper-ok-btn">
                                <button type="button" class="btn btn-ok capitalize" @click.once="clickOk()" :disabled="isConfirmed">
                                    {{ lbl.base_button.confirm }}
                                </button>
                            </div>
                            <div class="wrapper-cancel-btn py-4">
                                <button type="button" class="btn btn-cancel capitalize text-normal" @click="hide()">
                                    {{ lbl.base_button.cancel }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import { computed, inject } from "vue";
//import Button from '@/components/Button/Button.vue';
/**
 * @property {AlertModalController} controller (required) /components/Modal/Controller/AlertModalController.js
 */
import ConvertHeader from "../../../Header/ConvertHeader.vue";
export default {
    name: "ConfirmModal",
    components: {
        // Button,
        ConvertHeader,
    },
    props: {
        // busModal: Object,
        controller: Object,
    },
    setup: function () {
        const { lbl, localeCode } = inject("LocaleStore")
        const TheOneService = inject("TheOneService")
        const toApp = computed(() => {
            return lbl.value.module.exchange_name
        })

        return {
            lbl,
            localeCode,
            TheOneService,
            toApp
        }
    },
    data: function () {
        return {
            open: false,
            theme: "",
            title: "",
            message: "",
            btnOk: "",
            btnCancel: "",
            tag: "",
            partner: 0,
            blobConfig: {},
            pointConverted: 0,
            pointRaw: 0,
            busModal: null,
            theOneProfile: null,
            theOneNumber: "",
            theOneName: "",
            isCancel: false,
            isConfirmed: false
        };
    },
    computed: {
        user: function () {
            if (this.TheOneService.hasSignedIn.value) {
                return this.TheOneService.userTheOne.value
            }
            return null
        },
        cardNo: function () {
            if (this.user != null) {
                return this.user.cards?.[0]?.cardNo ?? '-'
            }
            return '-'
        },
        theOneFullName: function () {
            if (this.user != null) {
                if (this.localeCode.value == 1033) {
                    return `${this.user.firstName.en} ${this.maskLastName(this.user.lastName.en)}`
                } else {
                    return `${this.user.firstName.th} ${this.maskLastName(this.user.lastName.th)}`
                }
            }
            return '-'
        }
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.on("show", this.show);
        this.busModal.on("hide", this.hide);
    },
    methods: {
        onModalHidden: function () {
            this.controller.sendCallbackHidden({ tag: this.tag, cancel: this.isCancel });
        },
        clickOk: function () {
            this.isConfirmed = true
            this.isCancel = false
            this.hide()
            this.controller.sendCallbackOk({ tag: this.tag });
            this.$nextTick(this.onModalHidden)
        },
        show: function (config) {
            this.isConfirmed = false
            this.isCancel = false
            this.title = config.title;
            this.message = config.msg;
            this.btnCancel = config.btnCancel;
            this.btnOk = config.btnOk;
            this.tag = config.tag;
            this.theOneProfile = config.theOneProfile;
            this.theOneNumber = "0811111111" //this.theOneProfile.theoneNumber;
            this.theOneName = "The one customer name" //this.theOneProfile.strDisplayName;
            this.blobConfig = config.blobConfig;
            // console.log(this.blobConfig)
            this.pointRaw = config.pointRaw || 0
            this.pointConverted = config.pointConverted || 0

            if (Util.isEmptyStr(config.btnCancel)) {
                this.btnCancel = this.lbl.base_button.cancel;
            }
            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.base_button.ok;
            }
            document.body.classList.add('not-scroll');
            this.open = true
        },
        hide: function () {
            document.body.classList.remove('not-scroll');
            this.isCancel = true
            this.open = false
        },
        //#region private utility
        /**
        *
        * @param {string} val
        */
        maskLastName: function (val) {
            const marker = function (len) {
                let idx = 0;
                let str = ''
                while (idx < len) {
                    idx++
                    str += 'X'
                }
                return str
            }
            if (val.length < 5) {
                let fill = val.length - 1
                let fillStr = marker(fill)

                return `${val[0]}${fillStr}`
            } else {
                let fillStr = marker(4)
                let prefix = val.substring(0, val.length - 4)
                return `${prefix}${fillStr}`
            }
        }
        //#endregion
    },
};
</script>
<style lang="scss" scoped>
@import "@/style/modal.scss";
@import "../../../../style/base.scss";
@import "style/ConfirmModal.scss";

.modal {
    @extend %modal;

    .modal-content {
        width: 100%;
    }
}
</style>
